// Home
export const supportHomeUrl = 'https://support.flexcar.com/hc/en-us';
export const faqSupportUrl =
  'https://support.flexcar.com/hc/en-us/sections/20765395660443';

// Support Request
export const contactSupportUrl = 'https://support.flexcar.com/hc/en-us/requests/new';

// Articles
export const aboutDeliverySupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349026092571-Delivery';
export const aboutPickupSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349287495579-How-Does-Pickup-Work';
export const aboutReturnSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349305967387-How-Do-I-Return-My-Car';
export const aboutSwapSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349278632091-Swapping-your-car';

export const aboutInsuranceSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349264923547-How-does-the-insurance-coverage-work';
export const chargingEVsSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349286117147';
export const aboutEVsSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349277232539-Electric-Vehicle-Start-Guide';

export const aboutParkingSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349051446427-Where-Can-I-Park-My-Flexcar';
export const flexcarLocations =
  'https://support.flexcar.com/hc/en-us/sections/8349003738907-Flexcar-Locations';

export const howIsFlexcarDifferentSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349287270683-How-does-it-work';
export const whatsIncludedSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349265206171-What-s-included';
export const isThereReallyNoDownPaymentSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349291997979-What-does-the-refundable-deposit-cover';
export const canICancelAnytimeSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349288503579-How-do-I-return-my-car';
export const canISwapAnytimeSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349278632091-Swapping-your-car';
export const isMaintenanceCoveredSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349286998939-Maintenance-process';
export const howDoIKnowIfImEligibleSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349278134171-What-are-the-eligibility-requirements';
export const whatIsACHSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/27509997676187-What-is-ACH-And-Why-should-I-use-it-for-Payments';

// Terms and Conditions + Requirements
export const referralTermsSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349286169243';
export const additionalDriverRequirementsSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/22136146092699-What-are-the-Additional-Driver-eligibility-requirements';
export const eligibilityRequirementsSupportUrl =
  'https://support.flexcar.com/hc/en-us/articles/8349278134171-Eligibility-requirements';
